<template>
  <div id="app" v-title :data-title="$t('index.title')">
     <!-- 顶部状态栏 -->
      <div class="page_head_top hidden-md-and-down">
        <el-button type="text" @click="setLanguage('en')">ENG</el-button>
        <el-button type="text" @click="setLanguage('tw')">繁</el-button>
        <el-button type="text" @click="setLanguage('zh')">简</el-button>
        <el-button type="text" @click="toadmin()">{{$t("index.adminlogin")}}</el-button>
        <!-- <el-button type="text" ><i class="el-icon-share"></i></el-button> -->
      </div>
      <div class="page_head_title hidden-md-and-down">
          <div class="page_head_title_left">
              <a href="/"><img class="page_head_leftimg" src="/img/logo_top_left.png" /></a>
          </div>
      </div>
      <!-- 导航栏 -->
      <div class="page_head_btm hidden-md-and-down">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-submenu v-for="(item,index) in navigationData" :key="item.id" :index="index.toString()" @click.native="submenuClick(index)">
                  <template slot="title">{{item.name.split(',')[$store.state.i18nVal]}}</template>
                    <el-menu-item   v-for="(child,childIndex) in item.children" :index="index.toString()+'-'+childIndex.toString()" @click.native="openClick(child)">
                        {{child.name.split(',')[$store.state.i18nVal]}}
                    </el-menu-item>
              </el-submenu>
          </el-menu>
      </div>
      <!-- 顶部状态栏 --><!-- ≤992px 响应式栅格数或者栅格属性对象-->
      <div class="page_head_md hidden-md-and-up">
          <div class="page_head_md_top">
              <a class="page_logo" href="/">
                  <img class="page-logo__img" 
                  src="/img/logo_top_left.png" />
              </a>
          </div>
          <div class="page_head_md_btm">
              <el-button type="text"  @click="setLanguage('en')">ENG</el-button>
              <el-button type="text"  @click="setLanguage('tw')">繁</el-button>
              <el-button type="text" @click="setLanguage('zh')">简</el-button>
              <el-button type="text"  @click="drawer = true"><i class="el-icon-s-fold"></i></el-button>
          </div>
      </div>
      <el-drawer
          :visible.sync="drawer"
          size="100%">
          <template slot="title">
              <div style="padding-right: 1rem;">
                  <!-- <el-input placeholder="搜索" v-model="input3" class="input-with-select">
                      <el-button slot="append" icon="el-icon-search"></el-button>
                  </el-input> -->
                  <img style="width: auto;height: 3rem;" src="/img/logo_top_left.png" />
              </div>
          </template>
          <el-menu
              :title="''"
              default-active="1"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose">
              <el-submenu v-for="(item,index) in navigationData" :key="index" :index="item.id">
                  <template slot="title">{{item.name.split(',')[$store.state.i18nVal]}}</template>
                    <el-menu-item   v-for="child in item.children" :index="child.id" @click="openClick(child)">{{child.name.split(',')[$store.state.i18nVal]}}</el-menu-item>
              </el-submenu>
              </el-menu>
      </el-drawer>
      <router-view></router-view>  

      <div v-if="$route.path !='/'" class="hidden-md-and-up" style="padding: 10px;display: flex;justify-content: flex-end;">
        <el-button plain icon="el-icon-arrow-left" @click="indexback">{{$t("index.back")}}</el-button>
      </div>

       <footer>
            <div class="page_foot">
                <div class="page_foot_top">
                    <div class="container" style="background-image: url('../img/top_background_new.jpg');max-width: 100% !important;">
                        <ul class="seo_foot_list hidden-md-and-down">
                            <li class="seo_foot_item" v-for="(item,index) in navigationData" >
                                <a class="seo_foot_link" href="/">
                                    <span>{{item.name.split(',')[$store.state.i18nVal]}}</span>
                                </a>
                                <ul class="seo_foot_listv2">
                                    <li class="seo_foot_itemv2" v-for="child in item.children" :index="child.id">
                                        <a class="seo_foot_link" @click="openClick(child)" style="font-weight:100">
                                            <span>{{child.name.split(',')[$store.state.i18nVal]}}</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <div class="social_foot">
                            <a class="social_foot_item" href="https://www.facebook.com/profile.php?id=100075787063709">
                                <img class="social_foot_img" src="/img/facebook.svg" />
                            </a>
                            <a class="social_foot_item" href="https://www.instagram.com/gb.phil.orch/">
                                <img class="social_foot_img" src="/img/instagram.svg" />
                            </a>
                            <a class="social_foot_item" href="https://www.youtube.com/@nancymusicworkshop6651">
                                <img class="social_foot_img" src="/img/youtube.svg" />
                            </a>
                            <div class="social_foot_item">
                                <el-popover
                                    placement="top"
                                    title="用微信扫描二维码来关注我们官方微信"
                                    width="200"
                                    trigger="click">
                                    <img style="width: 100%;"  src="/img/weichat.jpg" />
                                    <img slot="reference" class="social_foot_img" style="cursor:pointer" src="/img/wechat.svg" />
                                </el-popover>
                            </div>
                            <a class="social_foot_item" href="https://weibo.com/u/7778386518">
                                <img class="social_foot_img" src="/img/weibo.svg" />
                            </a>
                            <a class="social_foot_item hidden-md-and-down" href="/">
                                <div class="hl_event_button">
                                    <el-button >{{$t("index.contactus")}}</el-button>
                                </div>
                            </a>
                        </div>
                        <div class="hidden-md-and-up">
                            <div class="white_event_button" style="text-align: center;margin-top: 1rem;">
                                    <el-button>{{$t("index.contactus")}}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page_foot_btm">
                    <div class="container hidden-md-and-down">
                        <div class="page_foot_btm_left">
                            <div class="other_foot">
                                <a href="/">{{$t("index.privacypolicy")}}</a>
                                <a href="/">{{$t("index.disclaimerclause")}}</a>
                                <a href="/">{{$t("index.termsconditionsuse")}}</a>
                            </div>
                            <p class="copyright">© {{new Date().getFullYear()}} {{$t("index.copyright")}}</p>
                        </div>
                        <!-- <div class="page_foot_btm_right">
                            <a href="/">
                                <img style="height: 5.125em;" src="https://www.hkphil.org/assets/shared/img/award-26thAnnual-CA-1x.png" />
                            </a>
                            <a href="/">
                                <img style="height: 5.125em;" src="https://www.hkphil.org/assets/shared/img/award-2020-BIW-1x.png" />
                            </a>
                        </div> -->
                    </div>
                    <!-- ≤992px 响应式栅格数或者栅格属性对象-->
                    <div class="container_md hidden-md-and-up">
                            <p style="cursor:pointer">{{$t("index.privacypolicy")}}</p>
                            <p>{{$t("index.disclaimerclause")}}</p>
                            <p>{{$t("index.termsconditionsuse")}}</p>
                            <p>© {{new Date().getFullYear()}} {{$t("index.copyright")}}</p>
                            <!-- <div class="page_foot_btm_right">
                                <a href="/">
                                    <img style="height: 5.125em;" src="https://www.hkphil.org/assets/shared/img/award-26thAnnual-CA-1x.png" />
                                </a>
                                <a href="/">
                                    <img style="height: 5.125em;" src="https://www.hkphil.org/assets/shared/img/award-2020-BIW-1x.png" />
                                </a>
                            </div> -->
                    </div>
                </div>
            </div>
        </footer>
    <el-backtop :visibility-height="100"></el-backtop>
  </div>
</template>
<meta name="viewport" content="width=device-width,initial-scale=1.0"/>
<script>
export default {
  name: 'app',
  data(){
    return{
        drawer: false,
        input3:'',
        navigationData:[],
        homeDisabled:true,
        musicianDisabled:false,
        listDisabled:false,
        indexHtml:'',
        breadcrumb:'',
        breadcrumbtitle:'',
        activeIndex: '',
        pcode:'',
        listItem:[],
    }
   },
  created(){
        this.getIndexData()
        this.autoChange();
  },
  methods: {
    submenuClick(index)
    {
        this.activeIndex = `${index}-${0}`
        this.openClick(this.navigationData[index].children[0])
    },
    toadmin()
    {
        window.open("http://www.gbphil.com:8080");
    },
    autoChange() {
        switch (this.$i18n.locale) {
        case "zh":
            this.$store.state.i18nVal = 0
            this.$i18n.locale = "zh";
            break;
        case "tw":
            this.$store.state.i18nVal = 1
            this.$i18n.locale = "tw";
            break;
        case "en":
            this.$store.state.i18nVal = 2
            this.$i18n.locale = "en";
        break;
        }
    },
    setLanguage(lang)
    {
      this.$i18n.locale = lang
      if(lang==='zh')
      {
        this.$store.state.i18nVal = 0
      }else if(lang==='tw')
      {
        this.$store.state.i18nVal = 1
      }else{
        this.$store.state.i18nVal = 2
      }
      this.$Cookies.set('language', lang)
      location.reload();
    },
    getIndexData()
    {
         this.$http({
            method: 'get',
            baseURL: this.$baseURL,
            url: '/api/Index/getnavigation',
            withCredentials: true,
         }).then(response=>{
            this.navigationData = response.data
         })
    },
    openClick(data)
    {
        this.drawer = false
        // 音乐家样式  music
       if(data.code==="guestconductor" || data.code==="listmusicians" || data.code==="musicdirector" || data.code==="musicianinresidence")
       {
            let param = {
                pcode:data.code,
            }
            param = encodeURI(JSON.stringify(param))
            param = encodeURI(param)
            switch (data.code) 
            {
                case 'guestconductor':
                this.$router.push({path:`/musician/guestconductor/${param}`})
                break;
                case 'listmusicians':
                this.$router.push({path:`/musician/listmusicians/${param}`})
                break;
                case 'musicdirector':
                this.$router.push({path:`/musician/musicdirector/${param}`})
                break;
                case 'musicianinresidence':
                this.$router.push({path:`/musician/musicianinresidence/${param}`})
                break;
            }
       }else if(data.children && data.children.length>0){//多子项页面样式  list
            let param = {
                code:data.code,
                levels:data.levels,
                id:data.id
            }
            param = encodeURI(JSON.stringify(param))
            param = encodeURI(param)
            this.$router.push({path:`/list/${param}`});
       } else{
            let param = {id:data.id}
            param = encodeURI(JSON.stringify(param))
            param = encodeURI(param)
            this.$router.push({path:`/container/${param}`})
       }
    },
    formatRichText(html){
            let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
            match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
            match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
            match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
            return match;
        });
        newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
            match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
            return match;
        });
        newContent = newContent.replace(/<br[^>]*\/>/gi, '');
        newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;"');  
        return newContent;
    },
    indexback()
    {
        this.$router.back()
    },
    handleSelect(key, keyPath) {
        // console.log(key, keyPath);
    },
    handleOpen()
    {

    },
    handleClose()
    {

    },
  }
}
</script>

<style lang="scss">
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
body {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
//PC端
@media screen and (min-width: 576px) {
    .slick_track_carousel{
        height: 36vw!important;
        .el-carousel__container{
            height: 36vw!important;
        }
    }
    .slick_track_img{
        height: 36vw!important;
    }
    .container{
        max-width:540px!important;
        padding-right: 11px!important;
        padding-left: 11px!important;
    }
    .full_width_blk{
        padding-top:81.875%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
    .social_foot{
        justify-content: center!important;
        margin-left: 2.6875rem!important;
        margin-right: 2.6875rem!important;
    }
}
@media screen and (min-width: 768px) {
    .slick_track_carousel{
        height: 36vw!important;
        .el-carousel__container{
            height: 36vw!important;
        }
    }
    .slick_track_img{
        height: 36vw!important;
    }
    .container{
        max-width:720px!important;
        padding-right: 11px!important;
        padding-left: 11px!important;
    }
    .full_width_blk{
        padding-top:81.875%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
    .social_foot{
        justify-content: center!important;
        margin-left: 2.6875rem!important;
        margin-right: 2.6875rem!important;
    }
}
@media screen and (min-width: 992px) {
    .slick_track_carousel{
        height: 36vw!important;
        .el-carousel__container{
            height: 36vw!important;
        }
    }
    .slick_track_img{
        height: 36vw!important;
    }
    .container{
        max-width:960px!important;
        padding-right: 11px!important;
        padding-left: 11px!important;
    }
    .full_width_blk{
        padding-top:51.875%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
    .social_foot{
        justify-content: center!important;
        margin-left: 2.6875rem!important;
        margin-right: 2.6875rem!important;
    }
}
@media screen and (min-width: 1200px) {
    .slick_track_carousel{
        height: 36vw!important;
        .el-carousel__container{
            height: 36vw!important;
        }
    }
    .slick_track_img{
        height: 36vw!important;
    }
    .container{
        max-width:1140px!important;
        padding-right: 11px!important;
        padding-left: 11px!important;
    }
    .full_width_blk{
        padding-top:39.84375%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
}
@media screen and (min-width: 1440px) {
    .slick_track_carousel{
        height: 36vw!important;
        .el-carousel__container{
            height: 36vw!important;
        }
    }
    .slick_track_img{
        height: 36vw!important;
    }
    .container{
        max-width:1340px!important;
        padding-right: 11px!important;
        padding-left: 11px!important;
    }
    .full_width_blk{
        padding-top:39.84375%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
    .el-backtop{
        font-size: 2em !important;
    }
}
// 移动端
@media screen and (max-device-width: 576px) {
    .slick_track_carousel{
        height: 50vw!important;
        .el-carousel__container{
            height: 50vw!important;
        }
    }
    .slick_track_img{
        height: 50vw!important;
    }
    .container{
        max-width:1340px!important;
        padding-right: 11px!important;
        padding-left: 11px!important;
    }
    .full_width_blk{
        padding-top:39.84375%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
}
@media screen and (max-device-width: 768px) {
    .slick_track_carousel{
        height: 50vw!important;
        .el-carousel__container{
            height: 50vw!important;
        }
    }
    .slick_track_img{
        height: 50vw!important;
    }
    .container{
    max-width:1140px!important;
    padding-right: 11px!important;
    padding-left: 11px!important;}
    .full_width_blk{
        padding-top:39.84375%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
}
@media screen and (max-device-width: 992px) {
    .slick_track_carousel{
        height: 50vw!important;
        .el-carousel__container{
            height: 50vw!important;
        }
    }
    .slick_track_img{
        height: 50vw!important;
    }
    .container{
    max-width:960px!important;
    padding-right: 11px!important;
    padding-left: 11px!important;}
    .full_width_blk{
        padding-top:39.84375%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
    .social_foot{
        justify-content: center!important;
        margin-left: 2.6875rem!important;
        margin-right: 2.6875rem!important;
    }
}
@media screen and (max-device-width: 1200px) {
    .slick_track_carousel{
        height: 50vw!important;
        .el-carousel__container{
            height: 50vw!important;
        }
    }
    .slick_track_img{
        height: 50vw!important;
    }
    .container{
    max-width:720px!important;
    padding-right: 11px!important;
    padding-left: 11px!important;}
    .full_width_blk{
        padding-top:81.875%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
    .social_foot{
        justify-content: center!important;
        margin-left: 2.6875rem!important;
        margin-right: 2.6875rem!important;
    }
}
@media screen and (max-device-width: 1440px) {
    .slick_track_carousel{
        height: 50vw!important;
        .el-carousel__container{
            height: 50vw!important;
        }
    }
    .slick_track_img{
        height: 50vw!important;
    }
    .container{
    max-width:1354px!important;
    padding-right: 11px!important;
    padding-left: 11px!important;}
    .full_width_blk{
        padding-top:81.875%!important;
    }
    .subscribe_box_inner{
        padding: 1.375rem!important;
    }
    .social_foot{
        justify-content: center!important;
        margin-left: 2.6875rem!important;
        margin-right: 2.6875rem!important;
    }
    .el-backtop{
        font-size: 1.5em !important;
    }
}

.el-backtop{
    color: white !important;
    background-color: #5d84b3 !important;
    height: 2.2em !important;
    width: 2.2em !important;
}

.container {
    margin-left: auto;
    margin-right: auto;
}
.page_head_btm{
    display: flex;
    padding-left: 4.0625rem;
    // padding-bottom: .5rem;
    .el-menu.el-menu--horizontal{
        border-bottom:none;
    }
}
.page_head_md{
    display: flex;
    justify-content: space-between;
    padding: .75rem 1.375rem;
    box-shadow: 0 2px 5px 0 rgba(50,50,50,.15);
    .page_head_md_top{
        .page_logo{
            text-decoration: none;
            img{
                height: 3rem;
                width: auto;
            }
        }
    }
    .page_head_md_btm{
        display: flex;
        justify-content: space-between;
        padding-left: 2rem;
        background: #fff;
        .el-button
        {
            margin-left:1.5rem;
        }
    }
}
.page_head_top {
    background-color: #f4f4f4;
    display: flex;
    justify-content: flex-end;
    padding-right: 3rem;
    .el-button{
        font-size: 16px;
        padding: 12px 10px;
    }
    .el-dropdown{
        font-size: 16px;
        padding: 12px 10px;
        .el-dropdown-link {
            cursor: pointer;
            color: #409EFF;
          }
          .el-icon-arrow-down {
            font-size: 16px;
          }
    }
}
.page_head_title{
    display: flex;
    justify-content:space-between;
    align-items: flex-end;
    padding: 1.4375rem 4.0625rem;
    border-bottom: 1px solid #efefef;
    .page_head_leftimg{
        width: auto;
        height: 5.9375rem;
        vertical-align: middle;
        border-style: none;
    }
    .page_head_rightimg{
        vertical-align: middle;
        border-style: none;
        height: 3.0625rem;
        width: auto;
    }
}
.white_event_button{
    .el-button{
        border: 1px  solid white !important;
        color: #FFF;
        background-color: transparent;
        border-color: transparent;
        font-size: .875rem;
        border-radius: 0;
    }
    .el-button:hover{
        color: #FFF;
        background-color: transparent;
        border-color: transparent;
    }
    .el-button:focus {
        color: #FFF;
        background-color:  transparent;
        border-color:  transparent;
    }
}
.page_foot{
    background-color: #404040;
    color: white;
    .page_foot_top{
        position: relative;
        z-index: 1;
        /* padding-top: 1.875rem;
        padding-bottom: 2.5rem; */
        color: #fff;
        .container{
            background-size: cover;
            background-position: center;
            /* filter: grayscale(1); */
            padding-top: 1.875rem;
            padding-bottom: 2.5rem;
            font-size: .875rem;
            .seo_foot_list{
                margin-bottom: 1.875rem;
                display: flex;
                padding: 0;
                list-style: none;
                .seo_foot_item{
                    display: list-item;
                    flex-basis: 16.66666667%;
                    .seo_foot_link{
                        padding: .4375rem 1.25rem .4375rem 2rem;
                        color: inherit!important;
                        font-weight: 700;
                        text-decoration: none;
                        line-height: 1.2;
                        display: block;
                        cursor: pointer;
                    }
                    .seo_foot_link:hover{
                       text-decoration: underline;
                       cursor: pointer;
                    }
                    .seo_foot_listv2{
                        margin: 0;
                        padding: 0;
                        list-style: none!important;
                        .seo_foot_itemv2{
                            display: list-item;
                        }
                    }
                }
            }
            .social_foot{
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;
                align-items: center;
                .social_foot_item{
                    margin: .6875rem;
                    transition-duration: .3s;
                    transition: color .3s,background-color .3s;
                    box-shadow: 0 0 1px transparent;
                    position: relative;
                    display: inline-block;
                    vertical-align: middle;
                    text-decoration: none;
                    background-color: transparent;
                    .social_foot_img{
                            width: 3.125rem;
                            height: 3.125rem;
                            vertical-align: middle;
                            border-style: none;
                        }
                        .hl_event_button{
                            .el-button{
                                border: 1px  solid white !important;
                                color: #FFF;
                                background-color: transparent;
                                border-color: transparent;
                                font-size: .875rem;
                                border-radius: 0;
                            }
                            .el-button:hover{
                                color: #FFF;
                                background-color: transparent;
                                border-color: transparent;
                            }
                            .el-button:focus {
                                color: #FFF;
                                background-color:  transparent;
                                border-color:  transparent;
                            }
                        }
                }
            }
        }
    }
    .page_foot_btm{
        padding-top: 2.1875rem;
        padding-bottom: 2.1875rem;
        background-color: #232323;
        .container{
            display: flex;
            justify-content: space-between;
            padding-left: 22px;
            padding-right: 22px;
            .page_foot_btm_left{
                .other_foot{
                    display: flex;
                    flex-direction: row-reverse;
                    margin-bottom: .71428571em;
                    justify-content: flex-end;
                    font-size: .875rem;
                    a{
                        margin-right: 2.14285714em;
                        color: white!important;
                        text-decoration: none;
                    }
                }
                .copyright{
                    margin-bottom: .6875rem;
                    font-size: .875em;
                }
                .statement{
                    font-size: .6875em;
                }
            }
            .page_foot_btm_right{
                display: flex;
            }
        }
        .container_md{
            display: flex;
            flex-direction: column;
            text-align: center;
            font-size: .875em;
        }
    }
}
.el-drawer__header{
    margin-bottom: 0 !important;
}
.el-submenu__title{
    font-size: 1em !important;
    font-weight: 500;
}
.el-submenu__title{
    color: #232323 !important;
}
.el-submenu__title:hover{
    color: #5d84b3 !important;
}
.el-submenu.is-active .el-submenu__title{
    border-bottom:2px solid #5d84b3 !important;
    color:#5d84b3 !important;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active, .el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title{
    color:#5d84b3 !important;
}
.el-menu-item:hover{
    background-color: #e3e3e3 !important;
    color:#5d84b3 !important;
}
.el-tabs__item.is-active{
    color:#5d84b3 !important;
}
.el-tabs__active-bar{
    background-color:#5d84b3 !important;
}
.el-popover{
    background:#5d84b3 !important;
    border:0 !important;
}
.el-popover__title{
    color: white !important;
    font-size: 14px !important;
}
.popper__arrow{
    color: #5d84b3 !important;
    border-top-color:#5d84b3 !important;
}
.popper__arrow::after{
    border-top-color:#5d84b3 !important;
}
</style>
